// Fold a crossword cell/entry string for cell-by-cell comparison. Mirrors the
// backend `crossword_author._normalise_letter_grid` (the source of truth for the
// stored `answer`): uppercase → German digraphs (Ä→AE, Ö→OE, Ü→UE, ß→SS) → strip
// remaining accents (é→E, ñ→N) → letters only. NOT the lowercase `normalizeForm`
// used elsewhere (that keeps digits/spaces and lowercases).
//
// Note: JS `"ß".toUpperCase()` is already "SS" and `"ä".toUpperCase()` is "Ä", so
// we iterate the uppercased string and still match the precomposed uppercase
// umlauts (and ß/ẞ defensively).
export function normaliseLetterGrid(s: string): string {
  const upper = (s ?? "").toUpperCase();
  let out = "";
  for (const ch of upper) {
    if (ch === "Ä") out += "AE";
    else if (ch === "Ö") out += "OE";
    else if (ch === "Ü") out += "UE";
    else if (ch === "ß" || ch === "ẞ") out += "SS";
    else {
      const folded = ch.normalize("NFKD").replace(/\p{M}/gu, "");
      for (const f of folded) {
        if (/\p{L}/u.test(f)) out += f;
      }
    }
  }
  return out;
}
